import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faFilter, faFilterCircleXmark, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiService } from '../../../services/apiService';
import Box from '@mui/material/Box';
import { MenuItem, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

function SameDomainRecuriters() {
    const { id } = useParams();
    const [myrequests, setMyRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingApply, setLoadingApply] = useState(false);
    

    // Tableview with filter
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [loadingPage, setLoadingPage] = useState(false);
    const [isGridVisible, setGridVisible] = useState(false);
    const [applyFilData, setApplyfilData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [innerSearch, setInnersearch] = useState("");

    const fetchRoots = useCallback(async (params = {}) => {
        setLoadingApply(true);
        try {
            const defaultParams = {
                per_page: params?.per_page ?? selectedRecord,
                search : innerSearch,
                filters: params?.filters ?? applyFilData,
                ...params,
            };
            const response = await apiService.postRequest(`c2c/recruiters/same-domain-recruiters/${id}`, defaultParams);
            if(response.success === true){
                setMyRequests(response.data);
                setPaginateData(response.meta);
                setShowRecord(response.meta?.per_page)
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
            setLoadingApply(false);
            setLoadingPage(false);
        }
    }, [ selectedRecord, applyFilData, id, innerSearch]);

    const handleSearchTable = () => {
        setApplyfilData(filters);
        fetchRoots({ filters });
        setCurrentPage(1);
    };
    const handleSearch = () => {
        setCurrentPage(1);
        setInnersearch(searchQuery);
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchRoots({ page: newPage, filters: applyFilData });
        setLoadingPage(true);
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    
    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const [filters, setFilters] = useState([{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);


    const combineOptions = [
        { value: 'and', label: 'And' },
        { value: 'or', label: 'Or' },
    ];
    
    const rows = myrequests.map((datas) => ({
        id: datas.id,
        formatid: datas?.company?.company_id,
        companyName: datas?.company?.company_name,
        companyUrl: datas?.company?.company_url,
        source: datas?.company?.source,
        name: datas?.name,
        email: datas?.email,
        phoneNumber: datas?.phone_number,
        lastActivity: datas?.last_activity,
        accuracy: datas?.accuracy,
    }));

    const handleFilterChange = (index, field, value) => {
        const updated = [...filters];
        if (field === "column") {
            updated[index][field] = value;
            // Set default operator to "range" when column is created_on
        if (value === "last_activity") { 
            updated[index].operator = "on";
            updated[index].value = "";
        } else {
            updated[index].operator = "contains";
            updated[index].value = "";
        }
        delete updated[index].start_date;
        delete updated[index].end_date;
        } else if (field === "value") {
            updated[index].value = value;
            if (value !== "custom") {
                delete updated[index].start_date;
                delete updated[index].end_date;
            }
        } else {
            updated[index][field] = value;
        }

        setFilters(updated);
    };

    const addFilter = () => {
        setFilters([...filters, { logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };

    const operatorOptions = [
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does Not Contain' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is Not' },
        { value: 'is_empty', label: 'Is Empty' },
        { value: 'is_not_empty', label: 'Is Not Empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'last_activity') {
            return [
                { value: 'on', label: 'On' },
                { value: 'not_on', label: 'Not On' },
                { value: 'before', label: 'Before' },
                { value: 'at_or_efore', label: 'At Or Before' },
                { value: 'after', label: 'After' },
                { value: 'at_or_after', label: 'At Or After' },
                { value: 'between', label: 'Between' },
                { value: 'is_empty', label: 'Is Empty' },
                { value: 'is_not_empty', label: 'Is Not Empty' },
            ];
        }
        return operatorOptions; // Default options
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            width: 300,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.name}</span>
                </div>
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.email}</span>
                </div>
            ),
        },
        {
            field: 'phoneNumber',
            headerName: 'Phone Number',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.phoneNumber}</span>
                </div>
            ),
        },
        {
            field: 'accuracy',
            headerName: 'Accuracy',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.accuracy}</span>
                </div>
            ),
        },
        {
            field: 'lastActivity',
            headerName: 'Last Activity',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span>{params.row.lastActivity}</span>
                </div>
            ),
        },
    ];
  return (
    <div>
        <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
            {isGridVisible && (
            <Box sx={{ mb: 2 }} className="my-4">
                {filters.map((filter, index) => (
                    <Box key={index} className="d-flex align-items-start flex-wrap">
                        {index > 0 && (
                            <select
                                label="Combine"
                                value={filter.logic}
                                onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                sx={{ mr: 1, minWidth: 80,mb:1 }}
                            >
                                {combineOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        )}
                        <TextField
                            select
                            label="Column"
                            value={filter.column}
                            onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                            sx={{ mr: 1, minWidth: 120,mb:1 }}
                        >
                            <MenuItem value="name">Name</MenuItem>
                            <MenuItem value="email_domain">Email Domain</MenuItem>
                            <MenuItem value="email">Email</MenuItem>
                            <MenuItem value="phone_number">Phone Number</MenuItem>
                            <MenuItem value="source">Source</MenuItem>
                            <MenuItem value="accuracy">Accuracy</MenuItem>
                            <MenuItem value="last_activity">Last Activity</MenuItem>
                        </TextField>
                        <TextField
                            select
                            label="Operator"
                            value={filter.operator}
                            onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                            sx={{ mr: 1, minWidth: 120,mb:1 }}
                        >
                            {getOperatorOptions(filter.column).map((option) => (
                                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                            ))}
                        </TextField>
                        {filter.operator === "is_not_empty" || filter.operator === "is_empty" ? "" :<>
                            {filter.column === 'accuracy' ? (
                                <select
                                    label="Value"
                                    value={filter.value}
                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                    sx={{ mr: 1, minWidth: 120,mb:1 }}
                                >
                                    <option value="" disabled>Select Accuracy</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                </select>
                            ) : (filter.column === 'last_activity') ? (
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        {filter.operator !== "between" ? 
                                        <DatePicker
                                            className="filterrages mb-2"
                                            label={"Value"}
                                            value={filter.value ? dayjs(filter.value) : null}
                                            onChange={(newValue) =>
                                                handleFilterChange(
                                                index,
                                                "value",
                                                newValue ? newValue.format("YYYY-MM-DD") : null
                                                )
                                            }
                                        />
                                        :<>
                                        <DatePicker 
                                        className="filterrages mb-2"
                                        label="Start Date"
                                        value={filter.start_date ? dayjs(filter.start_date) : null}
                                        onChange={(newValue) =>
                                            handleFilterChange(
                                            index,
                                            "start_date",
                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                            )
                                        }
                                        />
                                        <DatePicker
                                            label="End Date"
                                            className="filterrages mb-2 me-2"
                                            value={filter.end_date ? dayjs(filter.end_date) : null}
                                            onChange={(newValue) =>
                                                handleFilterChange(
                                                index,
                                                "end_date",
                                                newValue ? newValue.format("YYYY-MM-DD") : null
                                                )
                                            }
                                        />
                                        </>}
                                    </LocalizationProvider>
                                </Box>
                            ) :(
                                <input
                                    className='value_inputfilter mb-2'
                                    placeholder='Value'
                                    label="Value"
                                    value={filter.value}
                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                />
                            )}</>}
                        <button className='filterremovebtn mb-2 ms-1' onClick={() => removeFilter(index)}>Remove</button>
                    </Box>
                ))}
                <button className='registersendbtn1 mt-2 mb-0' onClick={addFilter}>Add Filter</button>
                <button className='registersendbtn2 mt-2 mb-0 ms-3' onClick={handleSearchTable}>
                    {loadingApply ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Apply'}
                </button>
            </Box>
        )}
            <Grid size={{xs:12}} container justifyContent="space-between">
                <Grid size={{ lg:4, sm:6, xs: 12 }} container flexDirection="column">
                    <div className='d-flex jobseekersearch my-4'>
                        <div className='col-md-9 input_jobssearch'>
                            <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                            <input type='text' placeholder='search'
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch(); // Trigger search on Enter key press
                                }
                            }}/>
                        </div>
                        <div className='col-md-3 col-4'>
                            <button onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                </Grid>
                <button className='show_filterbtn d-none' onClick={toggleGrid}>
                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                </button>
            </Grid>
            {loading ? 
                <div className='d-flex justify-content-center w-100'>
                    <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :<>
                {(myrequests && myrequests.length === 0) ?
                <span className='w-100 d-flex justify-content-center text-center'>No Data</span> :<>
                    {loadingPage ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <DataGrid
                            style={{minHeight:"200px"}}
                            rows={rows}
                            columns={columns}
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                        />
                    </>}
                    <Grid size={{xs:12}} container justifyContent="space-between">
                        <div className='d-flex justify-content-end align-items-center mt-3'>
                            <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                        </div>
                        <div className='d-none justify-content-end align-items-center mt-3'>
                            <label className='me-2'>No. of Rows</label>
                            <select
                                label="Rows per page"
                                value={selectedRecord || 20}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    setShowRecord(value);
                                    setCurrentPage(1);
                                }}
                                sx={{ mr: 2 }}
                            >
                                {[5, 10, 20, 50].map((size) => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage - 1)} 
                            disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        {paginatedata && paginatedata.last_page > 0 && (
                            <div className="pagination">
                                {(() => {
                                const totalPages = Math.max(1, paginatedata.last_page);
                                const pages = [];

                                const start = Math.max(2, currentPage - 2);
                                const end = Math.min(totalPages - 1, currentPage + 2);

                                // Always show page 1
                                pages.push(
                                    <button
                                    key={1}
                                    onClick={() => handlePageChange(1)}
                                    className={currentPage === 1 ? 'active' : ''}
                                    >
                                    1
                                    </button>
                                );

                                // Ellipsis after page 1 if needed
                                if (start > 2) {
                                    pages.push(<span key="start-ellipsis">...</span>);
                                }

                                // Middle pages
                                for (let i = start; i <= end; i++) {
                                    pages.push(
                                    <button
                                        key={i}
                                        onClick={() => handlePageChange(i)}
                                        className={currentPage === i ? 'active' : ''}
                                    >
                                        {i}
                                    </button>
                                    );
                                }

                                // Ellipsis before last page if needed
                                if (end < totalPages - 1) {
                                    pages.push(<span key="end-ellipsis">...</span>);
                                }

                                // Always show last page (if more than 1)
                                if (totalPages > 1) {
                                    pages.push(
                                    <button
                                        key={totalPages}
                                        onClick={() => handlePageChange(totalPages)}
                                        className={currentPage === totalPages ? 'active' : ''}
                                    >
                                        {totalPages}
                                    </button>
                                    );
                                }

                                return pages;
                                })()}
                            </div>
                        )}
                        <button className='arrowpaginate'
                            onClick={() => handlePageChange(currentPage + 1)} 
                            disabled={currentPage === paginatedata.last_page}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </Grid>
                </>}
            </>}    
        </Box>
    </div>
  )
}

export default SameDomainRecuriters
